// function to calculate the start of the week (Monday) for a given date
// accepts a week offset value for next week or last week or n weeks from now
export default (date, weekOffset = 0) => {
  //figure out the day offset for monday
  const monDate = date.getDate() - date.getDay() + (date.getDay() === 0 ? -6 : 1);
  return new Date(date.getFullYear(), date.getMonth(), monDate + (weekOffset * 7), 0, 0, 0);
};
